import type { ArtifactEnvelope } from "./artifact-contract"
import type { SkillProposal } from "./skill-proposal-contract"

export const SKILL_PACKAGE_ARTIFACT_TYPE = "skill-package"

export interface SkillPackageArtifact extends ArtifactEnvelope {
  type: typeof SKILL_PACKAGE_ARTIFACT_TYPE
  bundle: string
  description: string
}

export function skillPackageArtifactId(proposalId: string): string {
  return `skill-proposal-${proposalId}`
}

export function skillPackageArtifact(proposal: SkillProposal): SkillPackageArtifact | null {
  const { bundle } = proposal
  if (bundle === null) return null
  return {
    id: skillPackageArtifactId(proposal.proposalId),
    type: SKILL_PACKAGE_ARTIFACT_TYPE,
    title: proposal.name,
    bundle,
    description: proposal.description,
  }
}

export function isSkillPackageArtifact(artifact: ArtifactEnvelope): artifact is SkillPackageArtifact {
  return artifact.type === SKILL_PACKAGE_ARTIFACT_TYPE && typeof artifact.bundle === "string"
}
